module.exports = __webpack_public_path__ + "media/images/mypage/icon/green-pale/ico_avatar-8dda9e1b2de42a8f36e07899774fc8a9.svg";